import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalService } from '@boels/helpers';
import { Observable } from 'rxjs';
import { CarouselComponent } from '../carousel/carousel.component';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { TranslocoModule } from '@jsverse/transloco';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'boels-zoom-image',
  templateUrl: './zoom-image.component.html',
  styleUrls: ['./zoom-image.component.scss'],
  imports: [CarouselComponent, TranslocoModule, AsyncPipe],
})
export class ZoomImageComponent {
  private modalService = inject(ModalService);
  protected data = inject(MAT_DIALOG_DATA);

  thumbs$: Observable<any[]>;
  mainImage$: Observable<any>;
  faCircle = faCircle;
  openOnGalleryIndex = 0;

  constructor() {
    const data = this.data;

    this.thumbs$ = data.thumbs$;
    this.mainImage$ = data.mainImage$;
    this.openOnGalleryIndex = data.openOnGalleryIndex;
  }

  closeModal(): void {
    this.modalService.close();
  }
}
